import { createStyles, getDefaultZIndex } from '@mantine/core';

export const useStyle = createStyles((theme) => ({
	tabsList: {
		paddingTop: theme.spacing.md,
		borderBottom: `${theme.other.borderWidth.sm}px solid ${theme.other.getColor('border/secondary/default')}`,
		position: 'sticky',
		top: 0,
		zIndex: getDefaultZIndex('modal'),
		marginLeft: `-${theme.spacing.md}`,
		marginRight: `-${theme.spacing.md}`,
		paddingLeft: theme.spacing.md,
		paddingRight: theme.spacing.md,
	},
	tab: {
		'&[data-active]': {
			borderBottom: `${theme.other.borderWidth.sm}px solid ${theme.other.getColor('text/primary/default')}`,
			marginBottom: `-${theme.other.borderWidth.sm}px`,
		},
	},
	panel: {
		paddingTop: theme.spacing.md,
		paddingBottom: theme.spacing.md,
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
		minHeight: 0,
		overflow: 'hidden',
		position: 'relative',
	},
}));
